export default "__VITE_ASSET__481aa500__"